<script>
import { notificationService } from '@/services/notificationService';
export default {
  name: 'NotificationBell',
  data: () => ({ unread: 0 }),
  methods: {
    async refresh() { try { this.unread = (await notificationService.notifications()).unread_count || 0; } catch { /* Retry on focus or the next poll. */ } },
    update(event) { this.unread = event.detail; },
  },
  mounted() { this.refresh(); this.timer = setInterval(this.refresh, 60000); window.addEventListener('focus', this.refresh); window.addEventListener('student-notifications-changed', this.update); },
  beforeUnmount() { clearInterval(this.timer); window.removeEventListener('focus', this.refresh); window.removeEventListener('student-notifications-changed', this.update); },
};
</script>
<template><router-link to="/notifications" class="notification-bell" aria-label="الإشعارات"><i class="pi pi-bell"></i><span v-if="unread" class="notification-count">{{ unread > 99 ? '99+' : unread }}</span></router-link></template>
<style scoped>.notification-bell { position: relative; display: inline-flex; margin-inline: .75rem; padding: .5rem; font-size: 1.2rem; color: #D4AF37; }.notification-count { position: absolute; top: -.2rem; right: -.4rem; border-radius: 1rem; background: #b91c1c; color: white; padding: .1rem .3rem; font-size: .65rem; }</style>
